import { configureStore } from "@reduxjs/toolkit";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import { combineReducers } from "redux";
import settingsReducer from "./slices/settingsSlice";
import authReducer from "./slices/authSlice";
import gatewaysReducer from "./slices/gatewaysSlice";
import hostsReducer from "./slices/hostsSlice";
import usersReducer from "./slices/usersSlice";

const rootReducer = combineReducers({
  settings: settingsReducer,
  auth: authReducer,
  gateways: gatewaysReducer,
  hosts: hostsReducer,
  users: usersReducer,
});

const persistConfig = {
  key: "root",
  storage,
  whitelist: ["settings", "auth", "gateways", "hosts", "users"],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: getDefaultMiddleware => getDefaultMiddleware({ serializableCheck: false }),
});

export const persistor = persistStore(store);

export default store;
